import { render, staticRenderFns } from "./modalOrdenes.vue?vue&type=template&id=5602d3b0"
import script from "./modalOrdenes.vue?vue&type=script&lang=js"
export * from "./modalOrdenes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports